export type TagSeverity = 'primary' | 'gray' | 'success' | 'danger' | 'info' | 'warning' | 'danger-high' | 'yellow' | 'yellow-light';
export type TagSize = 'sm' | 'md' | 'lg'
export type TagContentPosition = 'left' | 'right'
export type TagBehaviour = 'static' | 'responsive'

export const severitySwitch = (severity: TagSeverity): string => {
  switch (severity) {
    case 'primary':
      return 'bg-yellow-200 text-brown-600';
    case 'gray':
      return 'bg-gray-100 text-gray-600';
    case 'success':
      return 'bg-green-100 text-green-800';
    case 'danger':
      return 'bg-red-50 text-red-500';
    case 'info':
      return 'bg-blue-100 text-blue-900';
    case 'warning':
      return 'bg-yellow-100 text-yellow-700';
    case 'danger-high':
      return 'bg-red-500 text-white';
    case 'yellow':
      return 'bg-yellow-200 text-yellow-800';
    case 'yellow-light':
      return 'bg-yellow-100 text-brown-600';
    default:
      return 'bg-yellow-200 text-brown-600';
  }
};


const SIZE_CLASSES: Record<TagBehaviour, Record<string, { label: string; padding: string; icon: string; }>> = {
  static: {
    lg: { label: 'text-sm', padding: 'py-1.5 px-2', icon: 'text-base' },
    md: { label: 'text-xs', padding: 'py-1 px-1.5', icon: 'text-sm' },
    sm: { label: 'text-2xs', padding: 'py-1 px-1.5', icon: 'text-sm' }
  },
  responsive: {
    lg: { label: 'text-xs lg:text-sm', padding: 'py-1 px-1.5 lg:py-1.5 lg:px-2', icon: 'text-sm lg:text-base' },
    md: { label: 'text-2xs xs:text-xs', padding: 'py-1 px-1.5', icon: 'text-sm' },
    sm: { label: 'text-2xs', padding: 'py-1 px-1.5', icon: 'text-sm' }
  },
};

export function getSizeSet(size: TagSize, behaviour: TagBehaviour) {
  return SIZE_CLASSES[behaviour][size];
}
